import { render, staticRenderFns } from "./protect.vue?vue&type=template&id=0a0e3472&"
import script from "./protect.vue?vue&type=script&lang=js&"
export * from "./protect.vue?vue&type=script&lang=js&"
import style0 from "./protect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProtectSidebar: require('/opt/build/repo/storefront/components/legacy/protect/protect-sidebar.vue').default,ProtectMessages: require('/opt/build/repo/storefront/components/legacy/protect/protect-messages.vue').default,LoadingOverlay: require('/opt/build/repo/storefront/components/legacy/global/loading-overlay.vue').default,ProtectFooter: require('/opt/build/repo/storefront/components/legacy/protect/protect-footer.vue').default})
